import {
    E_COMMERCE_CATEGORY,
    HEADER_BANNER_SHOW,
    Promotion,
    TrackHeaderActions,
    TrackHeaderBarBannerActions,
} from './types';
import { DataLayerManagerInterface } from './dataLayerManager/abstractDataLayerManager';

const HeaderEventCategory = 'Header';

export default class OneHeaderTracker {
    private dataLayerManager: DataLayerManagerInterface;

    public constructor(dataLayerManager: DataLayerManagerInterface) {
        this.dataLayerManager = dataLayerManager;
    }

    public trackBurgerMenuIconClick = () => {
        this.dataLayerManager.sendSpecificEvent('burgermenuclick', {
            category: HeaderEventCategory,
            action: 'Click on Menu icon',
        });
    };

    public trackBurgerItemClick = (name: string) => {
        this.dataLayerManager.sendSpecificEvent('burgermenuitemclick', {
            category: HeaderEventCategory,
            action: 'Click on Menu item',
            label: name,
        });
    };

    public trackSearchClicks = (label: string) => {
        this.dataLayerManager.sendGenericEvent({
            category: HeaderEventCategory,
            action: 'Search overlay clicks',
            label,
        });
    };

    public trackHeaderBarActions = (action: TrackHeaderBarBannerActions) => {
        this.dataLayerManager.sendGenericEvent({
            category: 'HeaderBarBanner',
            label: 'Header Bar Banner',
            action,
        });
    };

    public trackHeaderAction = (event: string, action: TrackHeaderActions, label?: string) => {
        this.dataLayerManager.sendSpecificEvent(event, {
            category: 'Header',
            action,
            label,
        });
    };

    public trackBurgerMenuImpression = (level: number) => {
        this.dataLayerManager.sendSpecificEvent('burgermenuimpressions', {
            category: HeaderEventCategory,
            action: 'Menu overlay show',
            label: `Menu overlay - Level ${level}`,
        });
    };

    public trackFirstCategoryPromoView(upperLevelCategory?: Promotion) {
        this.dataLayerManager.sendSpecificEvent(HEADER_BANNER_SHOW, {
            category: E_COMMERCE_CATEGORY,
            ecommerce: {
                promoView: {
                    promotions: upperLevelCategory ? [upperLevelCategory] : [],
                },
            },
        });
    }
}
